import { TypeTransaction } from "ts/enums/Transaction"

const POSITIVE_TRANSACTION_TYPES = new Set([
  TypeTransaction.BONUS,
  TypeTransaction.SALARY,
  TypeTransaction.REFUND,
  TypeTransaction.INTEREST,
])

const NEGATIVE_TRANSACTION_TYPES = new Set([
  TypeTransaction.FINE,
  TypeTransaction.EXPENSE,
  TypeTransaction.PURCHASE,
])

export const getSignByTransactionType = (
  type: string,
): "+" | "-" | undefined => {
  if (POSITIVE_TRANSACTION_TYPES.has(type as TypeTransaction)) return "+"
  if (NEGATIVE_TRANSACTION_TYPES.has(type as TypeTransaction)) return "-"
  return undefined
}

/**
 * Determines if a transfer is from checking account to savings account
 * based on the transaction title
 */
export const isTransferFromCheckingToSavings = (
  type: string,
  title: string,
): boolean => {
  if (type !== TypeTransaction.TRANSFER) {
    return false
  }

  const titleLower = title.toLowerCase()
  return /from\s+checking/i.test(titleLower)
}
